mutation Inertia_DestroyOrder($orderId: ID!) {
  destroyOrder(input: { orderId: $orderId }) {
    success
    errors
  }
}